import React from 'react';
import { useLocation } from 'react-router-dom';
import { __ } from '@wordpress/i18n';

// Fontawesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookSquare,
  faLinkedin,
  faTwitterSquare,
} from '@fortawesome/free-brands-svg-icons';

const Social = () => {
  const location = useLocation();
  const currentUrl = `${window.location.protocol}//${window.location.hostname}${location.pathname}${location.search}`;

  return (
    <nav className="hst-chart__social">
      <ul className="hst-chart__social-list">
        <li className="hst-chart__social-item">
          <a
            aria-label={__('Share on Facebook', 'hst')}
            className="hst-chart__social-link facebook"
            href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
            rel="noreferrer"
            target="_blank"
            title={__('Share on Facebook', 'hst')}
          >
            <FontAwesomeIcon icon={faFacebookSquare} />
          </a>
        </li>
        <li className="hst-chart__social-item">
          <a
            aria-label={__('Share on Twitter', 'hst')}
            className="hst-chart__social-link twitter"
            href={`https://twitter.com/share?text=National+Health+Spending+Explorer&url=${currentUrl}`}
            rel="noreferrer"
            target="_blank"
            title={__('Share on Twitter', 'hst')}
          >
            <FontAwesomeIcon icon={faTwitterSquare} />
          </a>
        </li>
        <li className="hst-chart__social-item">
          <a
            aria-label={__('Share on LinkedIn', 'hst')}
            className="hst-chart__social-link linkedin"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`}
            rel="noreferrer"
            target="_blank"
            title={__('Share on LinkedIn', 'hst')}
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </li>
        <li className="hst-chart__social-item">
          <button
            aria-label={__('Copy Chart Link', 'hst')}
            className="hst-chart__social-link link"
            onClick={() => navigator.clipboard.writeText(currentUrl)}
            title={__('Copy Chart Link', 'hst')}
            type="button"
          >
            <FontAwesomeIcon icon={faLink} />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Social;
